import {
  Box,
  createStyles,
  IconButton,
  makeStyles,
  Paper,
  Theme,
  Typography,
} from '@material-ui/core';
import { AccessTime, Delete, WhatsApp } from '@material-ui/icons';
import React, { useCallback, useState } from 'react';
import { IAppointmentDTO } from '../../../../shared/interfaces/appointment-interfaces';
import { AppointmentDeleteDialog } from './components/AppointmentDeleteDialog';

// type IAppointment = {
//   customer: string;
//   service: string;
//   startTime: string;
//   endTime: string;
//   value: number;
// };
type IProps = {
  appointment: IAppointmentDTO;
  timeOutside?: boolean;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      padding: theme.spacing(2),
      marginTop: theme.spacing(1),
      display: 'flex',
    },
    whatsapp: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
    },
  }),
);

const Appointment: React.FC<IProps> = ({ appointment, timeOutside = true }) => {
  const classes = useStyles();

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const handleClose = useCallback(() => {
    setOpenDeleteDialog(false);
  }, []);

  return (
    <>
      <Box display="flex" alignItems="center">
        {timeOutside && (
          <Box display="flex" alignItems="center" width="100px">
            <AccessTime color="primary" style={{ marginRight: '4px' }} />
            <Typography>{appointment.start_time}</Typography>
          </Box>
        )}
        <Paper className={classes.root}>
          <Box display="flex" width="100%">
            <Box flex={1}>
              <Typography style={{ fontWeight: 'bold' }}>
                {appointment.customer_name}
              </Typography>
              <Typography variant="subtitle2">
                {`${appointment.service.service_name} (${appointment.service.time_box} min)`}
              </Typography>
              <a
                href={`https://wa.me/55${appointment.customer_whatsapp}`}
                target="_blank"
                rel="noreferrer"
                className={classes.whatsapp}
              >
                <WhatsApp />
              </a>
            </Box>
            <IconButton onClick={() => setOpenDeleteDialog(true)}>
              <Delete />
            </IconButton>
          </Box>
          {!timeOutside && (
            <Box display="flex" alignItems="center">
              <AccessTime color="primary" style={{ marginRight: '4px' }} />
              <Typography>{appointment.start_time}</Typography>
            </Box>
          )}

          {/* <Box>
          {appointment.services.map(service => (
            <Typography variant="subtitle2">{`${service.name} - de ${service.startTime}hs a ${service.endTime}hs`}</Typography>
          ))}
        </Box> */}
        </Paper>
      </Box>
      <AppointmentDeleteDialog
        appointment={appointment}
        handleClose={handleClose}
        open={openDeleteDialog}
      />
    </>
  );
};

export default Appointment;
